import { Box } from "@mui/material";
import FrameGlassCard from "components/views/frame_glass_card";

export default function HomeSectionFrame(props) {
  return (
    <FrameGlassCard
      fullwidth={props.fullwidth ? true : false}
      borderRadius="18px"
    >
      <Box sx={{ padding: "12px 24px" }}>{props.children}</Box>
    </FrameGlassCard>
  );
}
